export const DISABLED_UNVERIFIED_BANNER_PATHS = [
  '/email-verification',
];

export const CREDIT_REFRESH_MODAL_KEY = 'growth/CreditRefreshModal';
